module.exports = __webpack_public_path__ + "img/residential bungalow - Bhadgaon.12da80b6.jpg";